var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 99,
    viewBox: "0 0 92 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.816 29.8776C20.7684 29.5335 19.6168 29.7262 18.7383 30.3925L13.5742 34.3112C11.3625 35.9896 8.18205 34.4089 8.19207 31.6367L8.21588 25.1632C8.21964 24.0624 7.6808 23.03 6.7748 22.4026L1.44277 18.7131C-0.840409 17.1331 -0.316605 13.6269 2.32873 12.78L8.50786 10.8022C9.55797 10.4659 10.3763 9.63529 10.6933 8.58113L12.563 2.38216C13.3637 -0.272499 16.8687 -0.85884 18.4927 1.38988L22.2872 6.64095C22.9325 7.53396 23.9776 8.05304 25.0804 8.02892L31.5678 7.88727C34.3459 7.82663 35.9875 10.9704 34.3459 13.2071L30.5126 18.4303C29.861 19.3184 29.6893 20.4698 30.0527 21.5091L32.1931 27.6206C33.1091 30.2377 30.6191 32.767 27.9801 31.9006L21.816 29.8776Z",
    fill: "#F4B942"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1101_48",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.816 29.8776C20.7684 29.5335 19.6168 29.7262 18.7383 30.3925L13.5742 34.3112C11.3625 35.9896 8.18205 34.4089 8.19207 31.6367L8.21588 25.1632C8.21964 24.0624 7.6808 23.03 6.7748 22.4026L1.44277 18.7131C-0.840409 17.1331 -0.316605 13.6269 2.32873 12.78L8.50786 10.8022C9.55797 10.4659 10.3763 9.63529 10.6933 8.58113L12.563 2.38216C13.3637 -0.272499 16.8687 -0.85884 18.4927 1.38988L22.2872 6.64095C22.9325 7.53396 23.9776 8.05304 25.0804 8.02892L31.5678 7.88727C34.3459 7.82663 35.9875 10.9704 34.3459 13.2071L30.5126 18.4303C29.861 19.3184 29.6893 20.4698 30.0527 21.5091L32.1931 27.6206C33.1091 30.2377 30.6191 32.767 27.9801 31.9006L21.816 29.8776Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1101_48)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4102 -0.071614C11.4102 -0.071614 17.2763 13.2691 21.9807 13.8467C26.685 14.4244 28.9488 12.6558 28.7012 14.6719C28.4537 16.6881 27.4162 22.3593 31.7846 22.8957C36.1529 23.432 43.3388 6.57748 43.3388 6.57748L16.8573 -5.54249L11.4102 -0.071614Z",
    fill: "white"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.251 68.7829C106.117 63.2449 100.509 58.8491 93.9789 59.5809C92.6801 59.7262 91.3994 60.0504 90.0945 60.0448C86.9123 60.0305 86.9997 58.3209 86.0806 55.9756C85.2158 53.7661 84.2274 51.5887 83.025 49.5359C80.6504 45.486 77.3296 41.9444 72.8185 40.2273C66.3576 37.7681 59.8516 38.9742 55.2049 44.1198C53.0653 46.4861 51.4832 49.3093 50.2327 52.2116C49.0785 54.8873 49.0243 59.7799 45.2364 60.0314C43.3168 60.159 41.6082 58.9105 39.7609 58.3799C34.1559 56.7726 27.6861 58.0504 23.184 61.6945C15.2707 68.1028 13.2034 82.3885 20.496 89.9535C24.1573 93.7516 29.1717 95.978 34.171 97.7707C48.1353 102.78 63.082 105.118 77.9383 104.618C93.563 104.091 114.742 94.0082 111.707 75.5821C111.33 73.3003 110.481 70.9538 109.251 68.7829Z",
    fill: "#B7C0EB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1101_48",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 39,
    width: 96,
    height: 66
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.251 68.7829C106.117 63.2449 100.509 58.8491 93.9789 59.5809C92.6801 59.7262 91.3994 60.0504 90.0945 60.0448C86.9123 60.0305 86.9997 58.3209 86.0806 55.9756C85.2158 53.7661 84.2274 51.5887 83.025 49.5359C80.6504 45.486 77.3296 41.9444 72.8185 40.2273C66.3576 37.7681 59.8516 38.9742 55.2049 44.1198C53.0653 46.4861 51.4832 49.3093 50.2327 52.2116C49.0785 54.8873 49.0243 59.7799 45.2364 60.0314C43.3168 60.159 41.6082 58.9105 39.7609 58.3799C34.1559 56.7726 27.6861 58.0504 23.184 61.6945C15.2707 68.1028 13.2034 82.3885 20.496 89.9535C24.1573 93.7516 29.1717 95.978 34.171 97.7707C48.1353 102.78 63.082 105.118 77.9383 104.618C93.563 104.091 114.742 94.0082 111.707 75.5821C111.33 73.3003 110.481 70.9538 109.251 68.7829Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1101_48)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.15
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.23357 48.1656C7.23357 48.1656 24.5141 97.3891 76.4479 101.366C128.382 105.343 15.5647 109.968 15.5647 109.968L-11.0428 68.6282L7.23357 48.1656Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.5509fbb37ce7d9dddb01c959105594bd.svg";
export { ForwardRef as ReactComponent };